import React from "react";
// Limitless imports
import {
    PORTAL_SELECTION_ROUTE,
    MFASetupScreen,
    POLICY_PAYMENTS_ACCESS,
    PublicContactUsScreen,
    POLICY_APP_ACCESS_EWA
} from "@limitless/portal";
import { RouteCreator } from "@limitless/navigation";
import LoginScreen from "../screens/LoginScreen";
import ExpertHeader from "../components/top-nav/expert-header/ExpertHeader";
import Settings from "../components/settings/Settings";
import OnboardingBadgeIcon from "../components/badge-icons/OnboardingBadgeIcon";
import TaskBadgeIcon from "../components/badge-icons/TaskBadgeIcon";
import KnowledgeScreen from "../screens/KnowledgeScreen";
import TaskListScreen from "../screens/TaskListScreen";
import AnnouncementsScreen from "../screens/AnnouncementsScreen";
import OnboardingScreen from "../screens/OnboardingScreen";
import PaymentScreen from "../screens/PaymentScreen";
import TutorialsScreen from "../screens/TutorialsScreen";
import ContactUsScreen from "../screens/ContactUsScreen";
import LegalScreen from "../screens/LegalScreen";

import OnboardingDetailScreen from "../screens/OnboardingDetailScreen";
import ExpertOptInScreen from "../screens/ExpertOptInScreen";

import HomeAlt from "@limitless/icons/HomeAlt";
import BookOpen from "@limitless/icons/BookOpen";
import CreditCard from "@limitless/icons/CreditCard";
import KnowledgeBase from "../components/knowledge-base/KnowledgeBase";
import ModernisedDashboardScreen from "../screens/ModernisedDashboardScreen";
import RatingDashboardScreen from "../screens/RatingDashboardScreen";
import ModernTaskListScreen from "../screens/ModernTaskListScreen";
import OnboardingDetailScreenWithTheme from "../screens/OnboardingDetailScreenWithTheme";

const commonNavItems = [
    PORTAL_SELECTION_ROUTE,
    {
        text: "Dashboard",
        breadcrumb: [{ text: "Dashboard" }],
        icon: <HomeAlt />,
        path: "/dashboard",
        component: ModernisedDashboardScreen,
        policy: POLICY_PAYMENTS_ACCESS
    },
    {
        path: "/dashboard/ratings",
        breadcrumb: [{ text: "Dashboard", href: "/dashboard" }, { text: "Ratings" }],
        component: RatingDashboardScreen
    },
    // {
    //     text: "Tasks",
    //     breadcrumb: [{ text: "Tasks" }],
    //     icon: <TaskBadgeIcon />,
    //     path: "/tasklist",
    //     component: TaskListScreen,
    //     policy: POLICY_APP_ACCESS_EWA
    // },
    {
        text: "Tasks",
        breadcrumb: [{ text: "Tasks" }],
        icon: <TaskBadgeIcon />,
        path: "/tasklist",
        component: ModernTaskListScreen,
        policy: POLICY_APP_ACCESS_EWA
    },
    {
        text: "Knowledge",
        breadcrumb: [{ text: "Knowledge Library" }],
        icon: <BookOpen />,
        path: "/knowledge",
        component: KnowledgeScreen
    },
    {
        text: "Onboarding",
        breadcrumb: [{ text: "Onboarding" }],
        icon: <OnboardingBadgeIcon />,
        path: "/onboarding",
        component: OnboardingScreen
    },
    {
        text: "Payment",
        breadcrumb: [{ text: "Payment" }],
        icon: <CreditCard />,
        path: "/payment",
        component: PaymentScreen,
        policy: [POLICY_PAYMENTS_ACCESS],
        useModernTheme: true
    },
    {
        path: "/settings",
        breadcrumb: [{ text: "Settings" }],
        component: Settings
    },
    {
        path: "/settings/:selectedSettingsItem",
        breadcrumb: [{ text: "Settings" }],
        component: Settings
    },
    {
        path: "/announcements",
        breadcrumb: [{ text: "Announcements" }],
        component: AnnouncementsScreen
    },
    {
        path: "/tutorials",
        breadcrumb: [{ text: "Tutorial videos" }],
        component: TutorialsScreen
    },
    {
        path: "/contactusscreen",
        breadcrumb: [{ text: "Contact Us" }],
        component: ContactUsScreen
    },
    {
        path: "/legal/:selectedLegalItem",
        breadcrumb: [{ text: "Legal" }],
        component: LegalScreen
    },
    {
        path: "/onboarding/detail",
        breadcrumb: [{ text: "Onboarding", href: "/onboarding" }, { text: "Onboarding Detail" }],
        component: OnboardingDetailScreenWithTheme
    },
    {
        path: "/onboarding/detail/:displayName",
        breadcrumb: [{ text: "Onboarding", href: "/onboarding" }, { dynamicText: true }],
        component: OnboardingDetailScreenWithTheme
    },
    {
        path: "/onboarding/opt-in",
        breadcrumb: [{ text: "Expert Opt-In" }],
        component: ExpertOptInScreen
    },
    {
        path: "/knowledge/:displayName",
        breadcrumb: [{ text: "Knowledge Library", href: "/knowledge" }, { dynamicText: true }],
        component: KnowledgeBase
    }
];

const Routes = () => {
    const EWANavItems = commonNavItems;

    const routerProps = {
        navItems: EWANavItems,
        rootComponent: function rootComponent() {
            return <LoginScreen />;
        },
        mfaComponent: function mfaComponent() {
            return <MFASetupScreen />;
        },
        contactUsComponent: function contactUsComponent() {
            return <PublicContactUsScreen />;
        },
        screenProps: {
            mode: "expert",
            renderHeaderOptions: function renderHeaderOptions(handleNavigation) {
                return <ExpertHeader navigate={handleNavigation} />;
            },
            helpDrawerAvailable: true
        }
    };

    return <RouteCreator {...routerProps} />;
};

export default Routes;
